import React, { PropsWithChildren } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';

interface SearchBarFiltersProps {
  DisplayOnDesktop?: boolean;
  FullWidth?: boolean;
  IsLoading: boolean;
}

function SearchBarFilters(props: PropsWithChildren<SearchBarFiltersProps>) {
  const { DisplayOnDesktop, FullWidth, IsLoading, children } = props;

  return (
    <div className={IsLoading ? 'd-none' : 'searchbar-filters px-24 pb-24'}>
      <Dropdown>
        <Dropdown.Toggle
          className={
            DisplayOnDesktop
              ? 'searchbar-filters-toggle dropdown-toggle-noarrow d-md-none'
              : 'searchbar-filters-toggle dropdown-toggle-noarrow'
          }
          size="sm"
          variant="filter"
        >
          <span className="me-8">Rajaa hakua</span>
          <Icon Name="chevron-down" />
        </Dropdown.Toggle>
        <Dropdown.Menu
          renderOnMount
          className={`searchbar-filters-menu ${
            DisplayOnDesktop
              ? 'bg-white searchbar-filters-menu-desktop d-md-block shadow-lg-none'
              : 'bg-white shadow'
          } py-0 ${FullWidth ? ' w-100' : ''}`}
        >
          <div
            className={
              DisplayOnDesktop
                ? 'pt-24 px-24 pb-32 py-md-0 px-md-0'
                : 'pt-24 px-24 pb-32'
            }
          >
            {children}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

SearchBarFilters.defaultProps = {
  DisplayOnDesktop: false,
  FullWidth: false,
};

export default SearchBarFilters;
export { SearchBarFilters };
export type { SearchBarFiltersProps };
